<template>
	<div :class="['view-form-item', {active: formSelect.questionCode === element.questionCode}]" style="width: calc(100% - 10px)" @click.stop="handleSelect(element)">
		<component :is="element.component" :value="element.defaultValue" :element="element" :formData="formData" />
		<div class="item-drag">
			<i class="el-icon-rank drag-icon"></i>
		</div>
		<div class="item-action">
			<i class="el-icon-copy-document" @click.stop="handleClone(element, index, formDesign)"></i>
			<i class="el-icon-delete" @click.stop.once="handleDelete(formDesign, index)"></i>
		</div>
	</div>
</template>

<script>
import components from "../../elements/view";
import { uuid, deepClone } from '../../utils/index';

export default {
	name: "Widget",
	components,
	props: {
		formData: {
			type: Object,
		},
		element: {
			type: Object,
		},
		index: {
			type: String | Number,
		}
	},
	computed: {
		formSelect() {
			return this.formData.formSelect;
		},
		formDesign() {
			return this.formData.formDesign;
		}
	},
	methods: {
		handleDelete(list, index) {
			if (list.length - 1 === index) {
                this.formData.formSelect = index ? list[index - 1] : {};
            } else {
                this.formData.formSelect = list[index + 1];
            }
            list.splice(index, 1);
			this.$emit('onChangeFormData', this.formData);
		},

		handleClone(element, index, list) {
			const key = uuid();
            const el = deepClone(element);
            list.splice(index + 1, 0, Object.assign(el, {
                key,
                questionCode: "q_" + key,
            }));
            this.formData.formSelect = list[index + 1];
			this.$emit('onChangeFormData', this.formData);
		},

		handleSelect(element) {
			if (this.formSelect === element) return;
			this.formData.formSelect = element;
			this.$emit('onChangeFormData', this.formData);
		},
	},
};
</script>

<style lang="scss" scoped>
.view-form-item {
	display: inline-block;
	position: relative;
	user-select: none;
	overflow: hidden;
	margin: 5px;
	border: solid 1px #DCDFE6;
	margin-bottom: 5px;
	padding: 20px;
	position: relative;
	cursor: pointer;

	&::before {
		content: "";
		width: 100%;
		height: 100%;
		background: transparent;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 3000;
	}

	&.move {
		outline-width: 0;
		height: 3px;
		box-sizing: border-box;
		font-size: 0;
		content: '';
		overflow: hidden;
		padding: 0;
		background: #409eff;
		border: 2px solid #409eff;
	}

	& > .item-drag {
		display: none;
		position: absolute;
		left: 0;
		top: 0;
		height: 25px;
		line-height: 25px;
		z-index: 30001;
		background: #409eff;

		i {
			font-size: 14px;
			color: #fff;
			margin: 0 5px;
			cursor: move;
		}
	}

	& > .item-action {
		display: none;
		position: absolute;
		right: 0;
		bottom: 0;
		height: 25px;
		line-height: 25px;
		z-index: 30001;
		background: #409eff;

		i {
			font-size: 14px;
			color: #fff;
			margin: 0 5px;
			cursor: pointer;
		}
	}

	&.active, &:hover {
		border: solid 1px #409eff;

		& > .item-drag {
			display: block;
		}

		& > .item-action {
			display: block;
		}
	}
}
</style>